import React from 'react';
import SideBar from '../../Sidebar';

export default function Sidebar() {
  return <SideBar />;
}
